<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M12.6 12.3h-2v3.2h2.1c.6 0 .9-.2 1.2-.5.3-.3.4-.6.4-1.1 0-.5-.1-.8-.4-1.1-.3-.3-.7-.5-1.3-.5M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6m1.2 14c-.6.5-1.1.7-2.4.7h-2.2V20H9v-9h3.8c1.3 0 1.9.3 2.4.8.6.6.8 1.2.8 2.1 0 .9-.2 1.6-.8 2.1M13 9V3.5L18.5 9H13z"/>
    </svg>
</template>

<script>
export default {
    name: 'FilePowerpointIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
